import { Button, Grid } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import staticFiles from "../services/staticApi";
import {
  emailMask,
  investmentDetailsPath,
  maskMobile,
  searchFilter,
  handleSort,
  getDate,
  onboardingoverviewPath,
} from "../utils/varialbles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ReactImageZoom from "react-image-zoom";
import FmdBadOutlinedIcon from "@mui/icons-material/FmdBadOutlined";
import Tooltip from "@mui/material/Tooltip";
const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function PersonalProfile() {
  const location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(true);
  const [investmentDetails, setInvestmeDetails] = useState([]);
  const [investmentDetailsDropDown, setinvestmentDetailsDropDown] = useState(
    []
  );
  const [dmatIndia, setDmatIndia] = useState([]);
  const [dmatCanada, setDmatCanada] = useState([]);
  const [dmatUSA, setDmatUSA] = useState([]);
  const [aadharText, setAadharText] = useState({});

  const [open, setOpen] = useState(false);
  const [KYCDetails, setKYCDetails] = useState({});
  const [approvalObject, setapprovalObject] = useState({});
  const [onboardingDialog, setonboardingDialog] = useState(false);

  const myparam = location.state;
  const handleClose = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    if (myparam && myparam.customer_id) {
      toast.loading("Please wait...");
      http
        .get("/personal_profile/" + myparam.customer_id)
        .then((res) => {
          toast.dismiss();
          if (
            res &&
            res.data &&
            res.data.data &&
            Array.isArray(res.data.data) &&
            res.data.data.length > 0
          ) {
            let newData = res.data.data;
            let group = newData.reduce((r, a) => {
              r[a.attribute] = [...(r[a.attribute] || []), a];
              return r;
            }, {});
            let finalValues = Object.values(group);

            setAadharText(res.data.KYC);

            setinvestmentDetailsDropDown(finalValues);
            setInvestmeDetails(res.data.data);
          } else {
            toast.error(
              "This user hasn't completed their personal profile yet."
            );
          }
          if (res && res.data && res.data.KYC) {
            setKYCDetails(res.data.KYC);
          }
          if (
            res &&
            res.data &&
            res.data.demat_Canada &&
            Array.isArray(res.data.demat_Canada)
          ) {
            setDmatCanada(res.data.demat_Canada);
          }
          if (
            res &&
            res.data &&
            res.data.demat_India &&
            Array.isArray(res.data.demat_India)
          ) {
            setDmatIndia(res.data.demat_India);
          }
          if (
            res &&
            res.data &&
            res.data.demat_USA &&
            Array.isArray(res.data.demat_USA)
          ) {
            setDmatUSA(res.data.demat_USA);
          }
        })
        .catch((err) => {});
    } else {
      history.goBack();
    }
  };
  useEffect(() => {
    handleCancel();
  }, []);
  const gotoProspectDetails = (e) => {
    e.preventDefault();
    history.push({
      pathname: investmentDetailsPath,
      state: myparam,
    });
  };

  const approveKYC = (e, type, status) => {
    setapprovalObject({
      type: type,
      status: status,
      value:
        type === 1
          ? "Aadhar"
          : type === 2
          ? "PAN"
          : type === 4
          ? "Onboarding Status"
          : "Agreement",
    });
    setOpen(true);
  };

  // To turn the dialog box and set the object values for onboarding status
  const completeOnboarding = (e, type, status) => {
    setapprovalObject({
      type: type,
      status: status,
      value: type === 4 ? "Onboarding Status" : "",
    });
    setonboardingDialog(true);
  };

  // console.log(approvalObject.value, "approvalObject");

  const submitApproval = (e) => {
    setOpen(false);

    if (
      approvalObject &&
      approvalObject.hasOwnProperty("type") &&
      approvalObject.hasOwnProperty("status")
    ) {
      http
        .patch("/personal_profile/" + myparam.customer_id + "/", {
          kyc: approvalObject.type,
          status: approvalObject.status,
        })
        .then((response) => {
          setapprovalObject({});
          if (response.data.data && response.data.statusCode === 0) {
            toast.success(response.data.data, { timeOut: 4500 });
            handleCancel();
            if (approvalObject.value === "Onboarding Status") {
              history.push({
                pathname: onboardingoverviewPath,
                state: myparam,
              });
            }
          } else {
            toast.error("Approval Request Failed..!");
          }
        })
        .catch((err) => {
          setapprovalObject({});
          toast.error("Approval Request Failed..!");
        });
    }
  };

  const aadhar_front = `${staticFiles}${KYCDetails.aadhar_front}`;
  const aadhar_back = `${staticFiles}${KYCDetails.aadhar_back}`;
  const pan_card = `${staticFiles}${KYCDetails.pan}`;
  const live = `${staticFiles}${KYCDetails.live}`;

  // (aadhar_front);
  // (aadhar_back);
  // (pan_card);

  const aadharFrontProps = {
    height: 150,
    width: 220,
    zoomWidth: 400,
    img: aadhar_front,
  };
  const aadharBackProps = {
    height: 150,
    width: 220,
    zoomWidth: 400,
    img: aadhar_back,
  };
  const panProps = { height: 150, width: 220, zoomWidth: 400, img: pan_card };
  const liveprops = { height: 150, width: 220, zoomWidth: 400, img: live };

  return (
    <Grid
      container
      style={
        showWindow
          ? { display: "block", marginBottom: 100 }
          : { display: "none" }
      }
    >
      <Paper className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={6} md={1}>
            <Button
              name="Overview"
              variant="contained"
              color="primary"
              onClick={gotoProspectDetails}
            >
              Overview
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Grid container style={{ marginTop: "10px" }}>
        <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
          <Typography color="textPrimary" variant="h5">
            Personal Profile
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "20px" }} className="personalProfile">
        {investmentDetailsDropDown.map((obj, inx) => {
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              key={inx}
              style={{ marginTop: "20px" }}
            >
              {obj[0].attribute}
              <Accordion style={{ width: "80%" }}>
                {obj
                  .sort((a, b) => {
                    return new Date(b["updateddt"]) - new Date(a["updateddt"]);
                  })
                  .map((sub, index) => {
                    return (
                      <>
                        {obj.length > 1 && index === 0 ? (
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            edge="start"
                            key={index + sub.attribute.trim}
                          >
                            <Typography style={{ fontweight: "bold" }}>
                              {sub.attribute === "Mobile Number"
                                ? sub.custresponse
                                : sub.attribute === "Email ID"
                                ? sub.custresponse
                                : sub.custresponse}
                            </Typography>
                          </AccordionSummary>
                        ) : obj.length > 1 && index !== 0 ? (
                          <AccordionDetails
                            key={index + sub.attribute.trim}
                            className={"overviewbar"}
                          >
                            <Grid item xs={12}>
                              <Typography
                                variant="body1"
                                style={{ color: "#6e6e6e" }}
                              >
                                {sub.attribute === "Mobile Number"
                                  ? sub.custresponse
                                  : sub.attribute === "Email ID"
                                  ? sub.custresponse
                                  : sub.custresponse}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography
                                variant="body1"
                                style={{ color: "#6e6e6e" }}
                              >
                                {getDate(sub.updateddt)}
                              </Typography>
                            </Grid>
                          </AccordionDetails>
                        ) : obj.length === 1 && index === 0 ? (
                          <AccordionDetails key={index + sub.attribute.trim}>
                            <Typography variant="body1">
                              {sub.attribute === "Mobile Number"
                                ? sub.custresponse
                                : sub.attribute === "Email ID"
                                ? sub.custresponse
                                : sub.custresponse}
                            </Typography>
                          </AccordionDetails>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  })}
              </Accordion>
            </Grid>
          );
        })}
      </Grid>

      {KYCDetails.aadhar_data || KYCDetails.pan_data ? (
        <Grid container style={{ marginTop: "50px" }}>
          <Grid item xs={12}>
            <Typography variant="h6">ID Proof</Typography>
          </Grid>
          {aadharText.aadhar_data ? (
            <h4
              style={{
                width: "100%",
                margin: "0px",
                padding: "10px 10px 0px 0px",
              }}
            >
              Aadhar Number :{" "}
              <span style={{ color: "#797F91" }}>
                {" "}
                {aadharText.aadharno ? aadharText.aadharno : "N/A"}
              </span>
            </h4>
          ) : (
            ""
          )}
          <br />
          {aadharText.aadhar_data ? (
            <h4
              style={{
                width: "100%",
                margin: "0px",
                padding: "0px 10px 10px 0px",
              }}
            >
              PAN Number :{" "}
              <span style={{ color: "#797F91" }}>
                {" "}
                {aadharText.panno ? aadharText.panno : "N/A"}
              </span>
            </h4>
          ) : (
            ""
          )}
          <Grid
            item
            xs={12}
            sm={12}
            style={
              KYCDetails.aadhar_data
                ? { marginTop: "10px" }
                : { display: "none", marginTop: "10px" }
            }
          >
            <Typography style={{ marginTop: "30px" }} variant="body1">
              {KYCDetails.aadhar_front ? "Aadhaar Card" : ""}
            </Typography>
            <Grid container style={{ marginTop: "10px" }}>
              {KYCDetails.aadhar_front && KYCDetails.aadhar_front.length > 0 ? (
                KYCDetails.aadhar_front.indexOf("pdf") > -1 ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      "https://savart.com" +
                      staticFiles +
                      KYCDetails.aadhar_front
                    }
                  >
                    Aadhar Front PDF
                  </a>
                ) : (
                  // <img alt='aadhar front' src={staticFiles + KYCDetails.aadhar_front} style={{ height: "150px", width: "220px" }}></img> : ""
                  <ReactImageZoom {...aadharFrontProps} />
                )
              ) : (
                ""
              )}
            </Grid>
            {/* <Typography style={{ marginTop: "30px" }} variant="body1">
              Aadhaar Card - Back
            </Typography> */}
            <Grid container style={{ marginTop: "10px" }}>
              {/* {KYCDetails.aadhar_back && KYCDetails.aadhar_back.length > 0 ? <img src={staticFiles + KYCDetails.aadhar_back} style={{ height: "150px", width: "220px" }}></img> : ""} */}
              {KYCDetails.aadhar_back && KYCDetails.aadhar_back.length > 0 ? (
                KYCDetails.aadhar_back.indexOf("pdf") > -1 ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      "https://savart.com" +
                      staticFiles +
                      KYCDetails.aadhar_back
                    }
                  >
                    Aadhar Back PDF
                  </a>
                ) : (
                  // <img alt='aadhar back' src={staticFiles + KYCDetails.aadhar_back} style={{ height: "150px", width: "220px" }}></img> : ""
                  <ReactImageZoom {...aadharBackProps} />
                )
              ) : (
                ""
              )}
            </Grid>

            {KYCDetails.aadhar_front ? (
              <Grid>
                {KYCDetails.aadhar_approved === true ? (
                  <Grid container xs={12} sm={12} style={{ marginTop: "10px" }}>
                    <Typography
                      variant="h6"
                      style={{ marginLeft: 0, marginTop: 30, marginBottom: 10 }}
                    >
                      Aadhar Status : Approved
                    </Typography>
                  </Grid>
                ) : KYCDetails.aadhar_approved === false ? (
                  <Grid container xs={12} sm={12} style={{ marginTop: "10px" }}>
                    <Typography
                      variant="h6"
                      style={{ marginLeft: 0, marginTop: 30, marginBottom: 10 }}
                    >
                      Aadhar Status : Declined
                    </Typography>
                  </Grid>
                ) : (
                  KYCDetails.aadhar_approved === null && (
                    <Grid
                      container
                      xs={12}
                      sm={12}
                      style={{ marginTop: "10px" }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          marginLeft: 0,
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        Aadhar Status : Pending
                      </Typography>
                    </Grid>
                  )
                )}
              </Grid>
            ) : (
              ""
            )}

            <Grid>
              {KYCDetails.aadhar_approved === null &&
              KYCDetails.aadhar_front ? (
                <>
                  <Button
                    variant="contained"
                    style={{
                      marginLeft: "25px",
                      backgroundColor: "#11BE74",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => approveKYC(e, 1, true)}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      marginLeft: "25px",
                      backgroundColor: "#D92212",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => approveKYC(e, 1, false)}
                  >
                    Decline
                  </Button>
                </>
              ) : (
                ""
              )}
            </Grid>

            {!KYCDetails.reason_aadhar ||
            KYCDetails.reason_aadhar === null ||
            KYCDetails.reason_aadhar === "" ? null : (
              <h2 style={{ fontWeight: "unset" }}>
                Aadhar Reason: {KYCDetails.reason_aadhar}
              </h2>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            style={
              KYCDetails.pan_data
                ? { marginTop: "30px" }
                : { display: "none", marginTop: "10px" }
            }
          >
            <Typography variant="body1">
              {KYCDetails.pan ? "PAN Card" : ""}
            </Typography>
            <Grid container>
              <Grid container style={{ marginTop: "10px" }}>
                {/* {KYCDetails.pan && KYCDetails.pan.length > 0 ? <img src={staticFiles + KYCDetails.pan} style={{ height: "130px", width: "220px" }}></img> : ""} */}
                {KYCDetails.pan && KYCDetails.pan.length > 0 ? (
                  KYCDetails.pan.indexOf("pdf") > -1 ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={"https://savart.com" + staticFiles + KYCDetails.pan}
                    >
                      PAN Card PDF
                    </a>
                  ) : (
                    // <img alt='pan' src={staticFiles + KYCDetails.pan} style={{ height: "150px", width: "220px" }}></img> : ""
                    <ReactImageZoom {...panProps} />
                  )
                ) : (
                  ""
                )}
              </Grid>

              {KYCDetails.pan ? (
                <>
                  {KYCDetails.pan_approved === true ? (
                    <Grid item xs={12} sm={2}>
                      <Typography
                        variant="h6"
                        style={{
                          marginLeft: 0,
                          marginTop: 30,
                          marginBottom: 10,
                        }}
                      >
                        Pan Status : Approved
                      </Typography>
                    </Grid>
                  ) : KYCDetails.pan_approved === false ? (
                    <Grid item xs={12} sm={2}>
                      <Typography
                        variant="h6"
                        style={{
                          marginLeft: 0,
                          marginTop: 30,
                          marginBottom: 10,
                        }}
                      >
                        Pan Status : Declined
                      </Typography>
                    </Grid>
                  ) : KYCDetails.pan_approved === null ? (
                    <Grid item xs={12} sm={2}>
                      <Typography
                        variant="h6"
                        style={{
                          marginLeft: 0,
                          marginTop: 30,
                          marginBottom: 10,
                        }}
                      >
                        Pan Status : Pending
                      </Typography>
                    </Grid>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {KYCDetails.pan_approved === null && KYCDetails.pan ? (
                <>
                  <Button
                    variant="contained"
                    style={{
                      marginLeft: "25px",
                      backgroundColor: "#11BE74",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => approveKYC(e, 2, true)}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      marginLeft: "25px",
                      backgroundColor: "#D92212",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => approveKYC(e, 2, false)}
                  >
                    Decline
                  </Button>
                </>
              ) : (
                ""
              )}
            </Grid>
            {!KYCDetails.reason_pan ||
            KYCDetails.reason_pan === null ||
            KYCDetails.reason_pan === "" ? null : (
              <h2 style={{ fontWeight: "unset" }}>
                Pan Reason: {KYCDetails.reason_pan}
              </h2>
            )}

            <Grid>
              <Typography
                variant="body1"
                style={{ display: "block", marginTop: 20 }}
              >
                {KYCDetails.agreement_link ? "Agreement" : ""}
              </Typography>
              <Grid container style={{ margin: "15px 0px" }}>
                {KYCDetails.agreement_link ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={staticFiles + KYCDetails.agreement_link}
                  >
                    Agreement PDF Link
                  </a>
                ) : (
                  ""
                )}
              </Grid>

              <Grid style={{ margin: "15px 0px" }}>
                {KYCDetails.agreement_link ? (
                  <Typography>
                    <span style={{ fontWeight: 700 }}>Agreement Status:</span>
                    {KYCDetails.agreement_status == null &&
                    KYCDetails.agreement_link ? (
                      <>
                        <Button
                          variant="contained"
                          onClick={(e) => approveKYC(e, 3, true)}
                          style={{
                            marginLeft: "25px",
                            backgroundColor: "#11BE74",
                            borderRadius: "8px",
                          }}
                        >
                          Aprove
                        </Button>
                        <Button
                          variant="contained"
                          style={{
                            marginLeft: "25px",
                            backgroundColor: "#D92212",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => approveKYC(e, 3, false)}
                        >
                          Declined
                        </Button>
                      </>
                    ) : KYCDetails.agreement_status == true ? (
                      " " + "Approved"
                    ) : KYCDetails.agreement_status == false ? (
                      " " + "Declined"
                    ) : (
                      ""
                    )}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>

            <Grid>
              <Typography variant="body1" style={{ display: "block" }}>
                Live Checkness
              </Typography>
              <Grid container style={{ marginTop: "10px" }}>
                {KYCDetails.live && KYCDetails.live.length > 0 ? (
                  KYCDetails.live.indexOf("pdf") > -1 ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={
                        "https://savart.com" + staticFiles + KYCDetails.live
                      }
                    >
                      Live checkness
                    </a>
                  ) : (
                    // <img alt='aadhar front' src={staticFiles + KYCDetails.aadhar_front} style={{ height: "150px", width: "220px" }}></img> : ""
                    <ReactImageZoom {...liveprops} />
                  )
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            {aadharText.show_force_onboard === true ? (
              <Grid container style={{ alignItems: "center" }}>
                <Grid item>
                  <Typography variant="h6">Onboarding Status: </Typography>
                </Grid>
                <Grid item>
                  <Tooltip arrow title="Move Customer to Investor Manager">
                    <Button
                      startIcon={<FmdBadOutlinedIcon />}
                      variant="contained"
                      style={{
                        marginLeft: "25px",
                        backgroundColor: "#FFFF00",
                        borderRadius: "8px",
                      }}
                      onClick={(e) => completeOnboarding(e, 4, true)}
                    >
                      Force Complete
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            <Grid item xs={12} sm={12} style={{ marginTop: "30px" }}>
              <Typography variant="h6">Demat</Typography>
              {/* {
                            dmatIndia.length > 0 ?
                             <></>
                            : "N/A"
                        } */}

              <Grid container>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <Typography variant="body1">India</Typography>
                  {dmatIndia.length > 0
                    ? dmatIndia.map((name, inx) => {
                        return (
                          <Typography variant="h6" key={inx + "dmindia"}>
                            {name ? name : "N/A"}
                          </Typography>
                        );
                      })
                    : "N/A"}
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <Typography variant="body1">USA</Typography>
                  {dmatUSA.length > 0
                    ? dmatUSA.map((name, inx) => {
                        return (
                          <Typography variant="h6" key={inx + "dmatUSA"}>
                            {name ? name : "N/A"}
                          </Typography>
                        );
                      })
                    : "N/A"}
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <Typography variant="body1">Canada</Typography>
                  {dmatCanada.length > 0
                    ? dmatCanada.map((name, inx) => {
                        return (
                          <Typography variant="h6" key={inx + "dmatCanada"}>
                            {name ? name : "N/A"}
                          </Typography>
                        );
                      })
                    : "N/A"}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {approvalObject.status ? "Approve " : "Decline "}{" "}
          {approvalObject.value}
        </DialogTitle>
        <DialogContent>
          Are you sure to {approvalObject.status ? "Approve " : "Decline "}{" "}
          {approvalObject.value}?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={(e) => submitApproval(e)}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={onboardingDialog}
        onClose={(e) => setonboardingDialog(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Onboarding Status
        </DialogTitle>
        <DialogContent>
          Are you sure to <b>Force Complete</b> onboarding status?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => setonboardingDialog(false)}
            variant="outlined"
          >
            No
          </Button>
          <Button
            autoFocus
            onClick={(e) => submitApproval(e)}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default PersonalProfile;
